import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChartWithMultipleDatasets = ({ dataArray, xKey, yKeys, labels, bgcolors, borderColors, horizontalLines = 7, yLableRoatation, showlegendTitle = true, legendTitleText = 'Bar chart with multiple datasets', showlegend = true, tooltipType = 'normal'  }) => {

    const labelsData = dataArray.map(item => item[xKey]);
    // const labels = dataArray.map(item => item.duration);
    // const depositsData = dataArray.map(item => parseFloat(item.deposits));
    // const withdrawalsData = dataArray.map(item => parseFloat(item.withdrawals));

    const datasets = yKeys.map((yKey, index) => ({
      label: labels[index],
      data: dataArray.map(item => parseFloat(item[yKey])),
      backgroundColor: bgcolors[index],
      borderColors: borderColors[index],
      barThickness: 8,
      maxBarThickness: 10,
      borderWidth: 0,
      borderRadius: 20,
      // barPercentage: 0.8,
      categoryPercentage: 1
    }));

      // Combine all dataset values into one array to calculate min and max values for the y-axis
  // const allDataValues = yKeys.flatMap(key => dataArray.map(item => parseFloat(item[key])));

  // const suggestedMin = Math.min(...allDataValues) - 50000;
  // const suggestedMax = Math.max(...allDataValues) + 50000;

  // // Calculate the step size based on the desired number of horizontal lines
  // const stepSize = (suggestedMax - suggestedMin) / (horizontalLines - 1); // Adjust for desired number of grid lines

  const data = {
    labels: labelsData,
    datasets: datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: showlegend,
        position: 'top',
        align:'start'
      },

      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw || 0;
            if (tooltipType === 'currency') {
              return `₹: ${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`; // Format in INR
            } else if(tooltipType === 'percent'){
              return `${value}%`;
            }
          },
        },
      },
      title: {
        display: showlegendTitle,
        text: legendTitleText,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: false,
        },
        ticks: {
          maxRotation: yLableRoatation,
          minRotation: yLableRoatation,
        },
      },
      y: {
        title: {
          display: false,
          text: 'Amount in USD',
        },
        grid: {
          display: true,
        },
      },
    },
  };

  return (
    <div>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChartWithMultipleDatasets;
